<div class="snackbar snackbar-{{ data.type }}">
    <span class="snackbar-message">{{ data.message }}</span>
    <button type="button" class="snackbar-close" (click)="onClose()">×</button>
</div>
